<div class="container">
    <button mat-stroked-button  (click)="collapseAll()" class="collapse-all">Collapse All Classes</button>
    <button mat-stroked-button  (click)="expandAll()" class="expand-all">Expand All Classes</button>
</div>